import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';

export const Wrapper = styled.div<{ focused: boolean; complete: boolean }>`
  width: 32px;
  height: 32px;
  min-width: 32px;
  border: 2px solid
    ${props =>
      props.focused || props.complete
        ? defaultTheme.colors.darkBlue
        : defaultTheme.colors.separator};
  border-radius: 16px;
  background-color: ${defaultTheme.colors.separator};
  ${props => props.complete && `background-color: ${defaultTheme.colors.darkBlue};`}
  ${props => props.focused && `background-color: white;`}
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 150%;
  font-weight: 600;
  color: ${defaultTheme.colors.secondaryGrey};
  ${props => props.focused && `color: ${defaultTheme.colors.darkBlue};`}
  ${props => props.complete && `color: white;`}
`;
